/* eslint-disable no-console -- this module is the only allowed console wrapper */

import { Sentry } from '@/lib/sentry';

// Thin logger so call sites have a single import path. In dev: passes through to console.
// In prod: routes warnings/errors through Sentry breadcrumbs in addition to console.

type LogContext = Record<string, unknown>;

function format(message: string, context?: LogContext): unknown[] {
  return context ? [message, context] : [message];
}

export const logger = {
  debug(message: string, context?: LogContext): void {
    if (import.meta.env.DEV) {
      console.debug(...format(message, context));
    }
  },

  info(message: string, context?: LogContext): void {
    console.info(...format(message, context));
    Sentry.addBreadcrumb({
      category: 'log',
      level: 'info',
      message,
      ...(context && { data: context }),
    });
  },

  warn(message: string, context?: LogContext): void {
    console.warn(...format(message, context));
    Sentry.addBreadcrumb({
      category: 'log',
      level: 'warning',
      message,
      ...(context && { data: context }),
    });
  },

  error(message: string, context?: LogContext): void {
    console.error(...format(message, context));
    Sentry.addBreadcrumb({
      category: 'log',
      level: 'error',
      message,
      ...(context && { data: context }),
    });
  },
};
